/* eslint-disable no-throw-literal */
import {
  ES_MYCARD_HUMAN_CSV,
  ES_MYCARD_CARD_CSV
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [ES_MYCARD_HUMAN_CSV] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/cards/human_csv', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [ES_MYCARD_CARD_CSV] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/cards/card_csv', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/card.js